'use strict'

var Marionette = require('marionette')
var App = require('app')

var PageBodyComponent = require('src/components/page-body-view')
var ListComponent = require('src/components/list-view')

/**
 * Page body layout
 * -----------------------------------------------------------------------------
 */
var LayoutView = PageBodyComponent.Layout.extend({})

module.exports.Layout = LayoutView

/**
 * List view
 * -----------------------------------------------------------------------------
 * List Component which supports paginating and bulk edit
 */
var ListView = ListComponent.ListView.extend({})

module.exports.ListView = ListView

/**
 * List item view
 * -----------------------------------------------------------------------------
 */
var ListItem = ListComponent.ItemView.extend({
  template: require('./templates/item.html'),
  templateContext: function () {
    var self = this
    return {
      formatTimeFromNow: App.TemplateHelpers.formatTimeFromNow,
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel,
      userHasRole: App.TemplateHelpers.userHasRole,
      getListColumns: function () {
        return self.options.columns
      },
      getHideClasses: App.TemplateHelpers.getHideClasses(self.options),                   
      getColumnField: function (field) {
        var value = _.get(this, field)

        switch (field) {
          case 'key':
          return value;
            // let keyParts = value.split('.')
            // console.log(keyParts)
            // return keyParts[2]
            // return App.TemplateHelpers.getUserRoleLabel(value)
            break
          case 'role':
            return App.TemplateHelpers.getUserRoleLabel(value)
            break
          case 'lastUsedAt':
            if (!value) return '-'
            return App.TemplateHelpers.formatTime(value)
            break
          case 'createdAt':
            return App.TemplateHelpers.formatTime(value)
            break
          default:
            return value
            break
        }
      }
    }
  }
})

module.exports.ListItem = ListItem



// WEBPACK FOOTER //
// ./js/modules/client-apikeys/list/view.js